(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-printing-page-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.custom-tab');
    const tabContents = document.querySelectorAll('.custom__tab-content');
    const tabOuter = document.querySelector('.custom--tab_outer');
    const accordions = document.querySelectorAll('.accordion details');
    const offset = 200;
    let isScrollingByClick = false;
    const tabOuterOffset = tabOuter.offsetTop;

    function isMobileView() {
      return window.innerWidth <= 768;
    }

    function handleTabClick(event) {
      if (isMobileView()) return; // Skip if mobile

      const contentId = event.target.dataset.contentId;
      const content = document.getElementById(contentId);

      tabs.forEach((t) => t.classList.remove('active'));
      event.target.classList.add('active');

      if (content) {
        isScrollingByClick = true;
        const yOffset = content.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: yOffset, behavior: 'smooth' });

        setTimeout(() => {
          isScrollingByClick = false;
        }, 500);
      }
    }

    function handleScroll() {
      if (isMobileView() || isScrollingByClick) return;

      if (window.scrollY >= tabOuterOffset) {
        tabOuter.classList.add('fixed-tab');
      } else {
        tabOuter.classList.remove('fixed-tab');
      }

      let activeTabIndex = -1;
      let minDistance = Infinity;

      tabContents.forEach((content, index) => {
        const rect = content.getBoundingClientRect();
        const contentTop = rect.top + window.scrollY - offset;
        const distance = Math.abs(window.scrollY - contentTop);

        if (rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2) {
          if (distance < minDistance) {
            minDistance = distance;
            activeTabIndex = index;
          }
        }
      });

      if (activeTabIndex !== -1) {
        tabs.forEach((t) => t.classList.remove('active'));
        tabs[activeTabIndex].classList.add('active');
      }
    }

    function handleAccordionToggle() {
      accordions.forEach((details) => {
        details.addEventListener('toggle', function () {
          if (this.open) {
            accordions.forEach((other) => {
              if (other !== this) {
                other.removeAttribute('open');
              }
            });
          }
        });
      });
    }

    // Attach event listeners
    tabs.forEach((tab) => tab.addEventListener('click', handleTabClick));
    window.addEventListener('scroll', handleScroll);
    handleAccordionToggle(); // Ensure accordion works properly
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.custom-tab');
    const tabContents = document.querySelectorAll('.custom__tab-content');
    const tabOuter = document.querySelector('.custom--tab_outer.wrapper-spacing--h');
    const accordions = document.querySelectorAll('.accordion details');
    const offset = 200;
    let isScrollingByClick = false;
    let tabOuterOffset = tabOuter.offsetTop;

    function isMobileView() {
      return window.innerWidth <= 768;
    }

    const observer = new MutationObserver((mutationsList, observer) => {
      setTimeout(() => {
        tabOuterOffset = tabOuter.offsetTop;
        // console.log('tabOuterOffset recalculated after mutation:', tabOuterOffset);

        // Stop observing after the first mutation
        observer.disconnect();
        // console.log('MutationObserver disconnected');
      }, 500);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    function handleTabClick(event) {
      if (isMobileView()) return; // Skip if mobile

      const contentId = event.target.dataset.contentId;
      const content = document.getElementById(contentId);

      tabs.forEach((t) => t.classList.remove('active'));
      event.target.classList.add('active');

      if (content) {
        isScrollingByClick = true;
        const yOffset = content.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: yOffset, behavior: 'smooth' });

        setTimeout(() => {
          isScrollingByClick = false;
        }, 500);
      }
    }

    function handleScroll() {
      if (isMobileView() || isScrollingByClick) return;
      if (window.scrollY >= tabOuterOffset) {
        tabOuter.classList.add('fixed-tab');
      } else {
        tabOuter.classList.remove('fixed-tab');
      }

      let activeTabIndex = -1;
      let minDistance = Infinity;

      tabContents.forEach((content, index) => {
        const rect = content.getBoundingClientRect();
        const contentTop = rect.top + window.scrollY - offset;
        const distance = Math.abs(window.scrollY - contentTop);

        if (rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2) {
          if (distance < minDistance) {
            minDistance = distance;
            activeTabIndex = index;
          }
        }
      });

      if (activeTabIndex !== -1) {
        tabs.forEach((t) => t.classList.remove('active'));
        tabs[activeTabIndex].classList.add('active');
      }
    }

    function handleAccordionToggle() {
      accordions.forEach((details) => {
        details.addEventListener('toggle', function () {
          if (this.open) {
            accordions.forEach((other) => {
              if (other !== this) {
                other.removeAttribute('open');
              }
            });
          }
        });
      });
    }

    // Attach event listeners
    tabs.forEach((tab) => tab.addEventListener('click', handleTabClick));
    window.addEventListener('scroll', handleScroll);
    handleAccordionToggle(); // Ensure accordion works properly
  });

  } catch(e) { console.error(e); }
})();
})();
